import { render, staticRenderFns } from "./Incompatibilities.vue?vue&type=template&id=421ffb43&scoped=true&"
import script from "./Incompatibilities.vue?vue&type=script&lang=js&"
export * from "./Incompatibilities.vue?vue&type=script&lang=js&"
import style0 from "./Incompatibilities.vue?vue&type=style&index=0&id=421ffb43&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421ffb43",
  null
  
)

export default component.exports